import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';

function MobileSosScreen() {
    const navigate = useNavigate();
    
  return (
    <div className='MainView'> 
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/MobileDashboard")}
        />
        <h1>Send SOS</h1>
    </div>
    <div className='topSpace'></div>
    <div className='mainWrapperListView '>
    <div>
        <p className='SosAlertTxt'>Select Alert</p>
    </div>
    <div className="famDetailsListInrMob margineTop10">
        <div className='SosRadioTxtView'>
        <input type='radio' className='checkBoxStyle' />
        <div>
            <p className='SosRadioTxt'>Alert Text SOS Message</p>
            <p className='SosRadioDiscTxt'>Sos Description Message</p>
        </div>
        </div>
    </div>
    <div className="famDetailsListInrMob margineTop10">
        <div className='SosRadioTxtView'>
        <input type='radio' className='checkBoxStyle' />
        <div>
            <p className='SosRadioTxt'>Alert Text SOS Message</p>
            <p className='SosRadioDiscTxt'>Sos Description Message</p>
        </div>
        </div>
    </div>
    <div className="famDetailsListInrMob margineTop10">
        <div className='SosRadioTxtView'>
        <input type='radio' className='checkBoxStyle' />
        <div>
            <p className='SosRadioTxt'>Alert Text SOS Message</p>
            <p className='SosRadioDiscTxt'>Sos Description Message</p>
        </div>
        </div>
    </div>
    <div className='inputSosandBtnView'>
        <input type='text' placeholder='Custom SOS' className='sosInput'/>
        <div className='SosBtnCenter'>
        <div className='sosBtnView margineTop10'>
            <p className='sendTxtSos'>Send</p>
            <p className='TxtSosBtn'>SOS</p>
        </div>
        </div>
    </div>
    
    </div>
    </div>
  )
}

export default MobileSosScreen